import { sumBy } from 'lodash-es';
import { useKarteItemsInfo } from '~/composables/karte/userKarteItemsInfo';
import { useStore } from '~/composables/useStore';
import { karteTrack, nonNullable } from '~/utils';
import { OrderSimulations } from '~/types/modules/order';

export const useKarteCartTag = () => {
  const store = useStore();
  const itemsInfo = useKarteItemsInfo();

  const setKarteCartTag = async (simulatedData?: Record<number, OrderSimulations>) => {
    let localSimulatedData = simulatedData;
    try {
      if (!localSimulatedData) {
        localSimulatedData = Object.fromEntries(
          await Promise.all(
            store.state.modules.cart.carts.map(async (cart) => {
              const simulation = await store.dispatch('modules/cart/postSimulation', {
                cartId: cart.cart_id,
              });
              return [cart.cart_id, simulation];
            })
          )
        );
      }
    } catch {
      // 何もしない
    }
    const { carts } = store.state.modules.cart;
    const cartIds = carts.map((cart) => cart.cart_id);
    const mergedSimulatedData: OrderSimulations[] = [];
    if (localSimulatedData) {
      mergedSimulatedData.push(
        ...Object.entries(localSimulatedData)
          .map(([key, value]) => {
            if (cartIds.includes(Number(key))) {
              return value;
            }
            return null;
          })
          .filter(nonNullable)
      );
    }
    const mergedPriceSet = mergedSimulatedData.map((data) => data.price_set);
    const itemsParam = await itemsInfo.getCartItemsInfo(mergedSimulatedData);
    const cartInfo = {
      price: sumBy(mergedPriceSet, 'item_total_amount'),
      tax_included_price: sumBy(mergedPriceSet, 'item_total_amount_including_tax'),
      quantity: sumBy(carts, ({ items }) => items.length),
      status: sumBy(mergedSimulatedData, 'item_quantity') > 0,
      // 商品情報の項目
      ...itemsParam,
    };
    const distributionPriceSet = store.state.modules.order.distributeSimulationRes?.price_set;
    if (distributionPriceSet) {
      cartInfo.price += distributionPriceSet.price_per_tax_rate_set['10'].total_amount;
      cartInfo.tax_included_price += distributionPriceSet.total_amount;
      cartInfo.quantity++;
      cartInfo.status ||= true;
    }
    karteTrack('cart', cartInfo);
  };

  return { setKarteCartTag };
};
